<template>
  <div class="login">
    <div class="login_form">
      <div class="login_box">
        <div class="login_bottom">
          <el-tabs v-model="activeName">
            <el-tab-pane style="margin-top: 8px" label="密码登录" name="pass">
              <passlogin />
            </el-tab-pane>
            <el-tab-pane style="margin-top: 8px" label="验证码登录" name="pwd"><phonelogin /></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import passlogin from "../components/common/login.vue";
import phonelogin from "../components/common/loginPhone.vue";
import { mapActions } from "vuex";
export default {
  name: "login",
  data() {
    return {
      activeName: "pass"
    };
  },
  components: {
    passlogin,
    phonelogin
  },
  created() {
    let data = {
      type: 4
    };
    this.GetProvinceCityArea(data).then(res => {
      console.log("res :>> ", res);
      sessionStorage.setItem("GetCity", JSON.stringify(res.data));
    });
  },
  methods: {
    ...mapActions({
      GetProvinceCityArea: "Address/GetProvinceCityArea"
    })
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}
::v-deep .el-tabs__item.is-top {
  font-size: 16px;
  color: #90c0d3;
  font-weight: 700;
}
::v-deep .el-tabs__item.is-active {
  font-weight: 700;
  color: #18e3eb;
  font-size: 16px;
}
::v-deep .el-tabs__active-bar {
  background-color: transparent;
}
::v-deep .el-tabs__item {
  color: #535353;
}
.logo {
  border-radius: 6px;
  overflow: hidden;
  width: 61px;
  height: 61px;
  background-color: #083f4b;
}
.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  //justify-content: center;
  background: url("../assets/img/login_bg.jpg") no-repeat;
  background-size: cover;
  //background: #000;
  .login_form {
    width: 500px;
    margin-left: 300px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    .login_box {
      // height: 260px;
      // padding: 0 50px;
      // background-color: rgba(255, 255, 255, 1);
      // box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
      // border-radius: 2px;
      width: 100%;
      .login_title {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .login_top {
          cursor: pointer;
          margin-left: 20px;
          font-size: 36px;
          font-weight: 700;
          background-image: -webkit-linear-gradient(bottom, #34f2b9, #0fafc9);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }

      .login_bottom {
        width: 100%;
        height: 440px;
        padding: 65px 55px;
        box-sizing: border-box;
        // background: rgba(0, 0, 0, 0.3);
        border-radius: 3px;
        position: relative;

        .submit_btn {
          margin-top: 25px;
          ::v-deep .el-form-item__content {
            margin-left: 20px !important;
            text-align: center;
          }
          ::v-deep .el-button {
            width: 100%;
            font-size: 26px;
            padding: 23px 0;
            border-radius: 36px;
          }
          ::v-deep .el-button--primary {
            background-color: #1a72fe;
            border-color: #1a72fe;
          }
        }
      }
    }
    .login_img {
      img {
        height: auto;
      }
      img {
        position: absolute;
        top: 0;
        left: 50%;
        z-index: 1;
        width: 10rem;
      }
      .normal {
        transform: translate(-50%, -83%);
      }
      .greeting {
        transform: translate(-50%, -75.8%);
      }
      .blindfold {
        width: 8.6rem;
        transform: translate(-50%, -75%);
      }
    }
  }
}

::v-deep .el-input__inner {
  border: 1px solid #00c0ff;
  background: rgba(78, 224, 226, 0.3);
}

::v-deep .el-input__inner::placeholder {
  color: #fff;
}

::v-deep .el-input__icon {
  margin-left: 4px;
  color: #eee;
}
</style>
